import { render, staticRenderFns } from "./SignForm.vue?vue&type=template&id=db560d0a&scoped=true&lang=pug"
import script from "./SignForm.vue?vue&type=script&lang=js"
export * from "./SignForm.vue?vue&type=script&lang=js"
import style0 from "./SignForm.vue?vue&type=style&index=0&id=db560d0a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db560d0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db560d0a')) {
      api.createRecord('db560d0a', component.options)
    } else {
      api.reload('db560d0a', component.options)
    }
    module.hot.accept("./SignForm.vue?vue&type=template&id=db560d0a&scoped=true&lang=pug", function () {
      api.rerender('db560d0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/event/anniversary2023/components/SignForm.vue"
export default component.exports